import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import "../styles/CategoryList.css";
import AddIcon from "@material-ui/icons/Add";
import CategoryDataService from "../../services/CategoryService";
import { useEffect } from "react";
import DomainService from "../../services/DomainService";
import CategoryItem from "./CategoryItem";
import { css } from "@emotion/react";
import SyncLoader from "react-spinners/SyncLoader";
import { AddCategoryModal, AddGroupModal } from "./CategoryModals";
const override = css`
  position: abolute;
  left: vh;
`;

const loadingColor = "#8C9BD8";

const CategoryList = () => {
  //add modal state
  const [addModalOpen, setAddModalOpen] = useState(false);
  //new category name
  const initialCategory = {
    name: "",
    group_id: 1,
    order_num: null,
  };
  const [categories, setCategories] = useState([]);
  // ALL DOMAINS
  const [domains, setDomains] = useState([]);
  //loading
  const [loading, setLoading] = useState(true);
  //new category
  //category group modal open
  const [newGroupModalOpen, setNewGroupModalOpen] = useState(false);
  //new category group
  const initialGroup = {
    name: "",
    domain_id: 1,
  };

  //list of groups
  const [categoryGroups, setCategoryGroups] = useState([]);

  useEffect(() => {
    if (categories && categories.length > 0) {
      setLoading(false);
    }
  }, [categories]);

  //load categories on open
  useEffect(() => {
    CategoryDataService.getAll()
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => console.log("error getting categories: " + error));

    DomainService.getAllMin()
      .then((response) => setDomains(response.data))
      .catch((error) => console.log("error getting domains: " + error));

    //get all category groups
    CategoryDataService.getAllCategoryGroups()
      .then((response) => {
        setCategoryGroups(response.data);
      })
      .catch((error) => console.log("error getting categoryGroups: " + error));
  }, []);

  const getAll = () => {
    CategoryDataService.getAll()
      .then((response) => {
        setCategories(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log("error getting categories: " + error);
        setLoading(false);
      });
  };

  //open add modal
  const handleAddOpen = () => {
    setAddModalOpen(true);
  };

  const handleGroupModalOpen = () => {
    setNewGroupModalOpen(true);
  };

  return (
    <div className="body-area">
      <div className="top-area">
        <div className="page-title">
          <h1>Categories</h1>
        </div>

        <div className="add-buttons">
          <Button
            className="category-add-button blue"
            onClick={handleGroupModalOpen}
            style={{
              color: "white",
              padding: "0 2rem",
              display: "flex",
              alignItems: "center",
              fontWeight: "500",
              justifyContent: "center",
              margin: "2rem",
            }}
          >
            <AddIcon fontSize="large" /> Group
          </Button>
          <AddGroupModal
            open={newGroupModalOpen}
            initialGroup={initialGroup}
            setLoading={setLoading}
            setIsOpen={setNewGroupModalOpen}
            domains={domains}
          />
          <Button
            className="category-add-button orange"
            onClick={handleAddOpen}
            style={{
              color: "white",
              padding: "0 2rem",
              display: "flex",
              alignItems: "center",
              fontWeight: "500",
              justifyContent: "center",
            }}
          >
            <AddIcon fontSize="large" /> Category
          </Button>
          <AddCategoryModal
            isOpen={addModalOpen}
            domains={domains}
            initialCategory={initialCategory}
            setIsOpen={setAddModalOpen}
            allGroups={categoryGroups}
          />
        </div>
      </div>
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "40vh",
          }}
        >
          <SyncLoader
            color={loadingColor}
            loading={loading}
            css={override}
            speedMultiplier={1.2}
            style={{ marginLeft: "auto auto" }}
          />
        </div>
      ) : (
        <div className="content-area">
          <ul className="category-list">
            {categories &&
              categories.map((cat, index) => {
                return (
                  <li>
                    <CategoryItem
                      category={cat}
                      key={index}
                      getAll={getAll}
                      domains={domains}
                      allGroups={categoryGroups}
                    />
                  </li>
                );
              })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CategoryList;
